module.exports = __webpack_public_path__ + "img/hr-rock-medium-01.cde813f4.png";